import { Link } from 'react-router-dom';
import {
  AppBar, Container, Fab, Grid,
  Link as MuiLink,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { UserPlusIcon } from '@client/components/Main/MainNav/common/UserPlusIcon';
import { appBar } from '@client/theme/mixins';
import { openLoginModal } from '@client/components/Main/Login';
import { openSignupModal } from '@client/components/Main/Signup';
import { useSelector } from '@client/hooks/redux.hooks';
import { getSessionUserState } from '@client/selectors/helpers/login';
import { newsUrl } from '@sda/utils/url';
import type { ContainerProps } from '@mui/material';

const drawerWidth = 86;

const useStyles = makeStyles({ name: 'Header' })((theme) => ({
  appBar: {
    ...appBar(theme),
    width: `calc(100% - ${drawerWidth}px)`,
  },
  appBarSpacer: {
    ...appBar(theme),
    marginBottom: theme.spacing(6),
  },
  gridContainer: {
    ...appBar(theme),
  },
  link: {
    '&.active': {
      fontWeight: 600,
    },
  },
  signupIcon: {
    marginRight: theme.spacing(1),
    fontSize: 24,
  },
}));

export const Header: React.FC<ContainerProps> = ({ ...ContainerProps }) => {
  const isLoggedIn = useSelector(getSessionUserState);
  const { classes } = useStyles();

  return (
    <>
      <AppBar
        position="fixed"
        className={classes.appBar}
      >
        <Container
          maxWidth="md"
          {...ContainerProps}
        >
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            className={classes.gridContainer}
          >
            <Grid item>
              <MuiLink
                component={Link}
                to="/home"
                variant="subtitle2"
                color="textPrimary"
                underline="none"
              >
                Side Door
              </MuiLink>
            </Grid>

            <Grid item>
              <Grid
                container
                alignItems="center"
                spacing={3}
              >
                <Grid item>
                  <MuiLink
                    href={newsUrl('/pricing')}
                    variant="subtitle1"
                    color="textPrimary"
                    underline="none"
                    className={classes.link}
                  >
                    Pricing
                  </MuiLink>
                </Grid>

                <Grid item>
                  <MuiLink
                    href={newsUrl('/host')}
                    variant="subtitle1"
                    color="textPrimary"
                    underline="none"
                    className={classes.link}
                  >
                    I'm a Host
                  </MuiLink>
                </Grid>

                {isLoggedIn === false && (
                  <>
                    <Grid item>
                      <MuiLink
                        component="button"
                        onClick={() => openLoginModal()}
                        variant="subtitle1"
                        color="textPrimary"
                        underline="none"
                      >
                        Log In
                      </MuiLink>
                    </Grid>

                    <Grid item>
                      <Fab
                        onClick={() => openSignupModal()}
                        color="secondary"
                        variant="extended"
                      >
                        <UserPlusIcon className={classes.signupIcon} />

                        Sign Up
                      </Fab>
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </AppBar>

      <div className={classes.appBarSpacer} />
    </>
  );
};

export default Header;
